import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WeedfreeFormMmtComponent } from '../components/weedfree/forms/weedfree-form-mmt/weedfree-form-mmt.component';

@Injectable({
  providedIn: 'root'
})
export class UploadInProgressGuard implements CanDeactivate<WeedfreeFormMmtComponent> {
  canDeactivate(component: WeedfreeFormMmtComponent): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    if (component.uploadProgress != 0)
      return false;
    
    return true;
  }
  
}
